<div style="margin-left: 2%">
  <ng-container id="üstMenü">
    <div *ngIf="visible" style="font-size: 18px">
      <b
        ><ng-container *ngFor="let item of inventionDetailData; let i = index">
          Buluş Adı:{{ item.inventionName }}
        </ng-container></b
      >
    </div>
    <div *ngIf="visible">
      <ng-container *ngFor="let item of inventionDetailData; let i = index">
        Dosya No:{{ item.documentNumber }}
      </ng-container>
    </div>
    <div *ngIf="visible">
      <ng-container *ngFor="let item of inventionDetailData; let i = index">
        Dosya Durumu:{{ status }}
      </ng-container>
    </div>
  </ng-container>
  <ng-container style="margin-left: -19%">
    <button class="btn" (click)="navigate()">Üst Menüye Git</button>
  </ng-container>
  <p></p>
  <ng-container *ngIf="visible">
    <h2 style="color: #d70040">
      Aşağıdaki seçeneklerden birini seçiniz.
    </h2>
    <p></p>
    <div>
      <button class="btn btn-primary" (click)="sendInvStatusMailtoAll()">
        1-) Buluşta belirtilen bütün Buluş Sahiplerine buluşun son durumunu
        e-posta gönder, Buluşun Son Durumu:{{ status }}
      </button>
    </div>
    <br />
    <div *ngFor="let item of inventorData; let i = index">
      <button
        class="btn btn-warning"
        (click)="sendInvStatusMail1Person(item.mail, item.name, item.share)"
      >
        {{ i + 2 }}-) Güncel durum e-postasını sadece {{ item.mail }} adresine
        gönder, Buluşun Son Durumu:{{ status }}
      </button>
      <p></p>
    </div>
  </ng-container>
  <h1 style="color: #d70040">{{ message }}</h1>
</div>
